import React from 'react';
import './App.css';

function App() {
  console.log('App component is rendering');
  return (
    <div className="App">
      <header className="App-header">
        <h1>NotesWriter</h1>
        <p>
          Your personal note-taking companion
        </p>
        <div className="dashboard-buttons">
          <button className="btn btn-primary">Get Started</button>
          <button className="btn btn-secondary">Sign In</button>
        </div>
      </header>
    </div>
  );
}

export default App;